/**
 * Constants for Supplier Performance module
 */

import { DEFAULT_FILTER_VALUES } from '../../components/suppliers/SupplierPerformanceFilters';

// CR-4782: Default to Last 12 Months (excluding current month) with N/A ratings
// excluded, so users land on a clean, relevant view without adjusting filters.
// CR-7264 rework: the values live with the filter panel (which also owns
// Clear all), so the page opens on and clears back to the same view.
export const DEFAULT_FILTERS = DEFAULT_FILTER_VALUES;

export const MODAL_PAGE_SIZE = 20;
